import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { optionLabel } from '../format';
import type { ControlProps } from './types';

/**
 * One of the setting's `enum` values. Radix Select takes strings, so each
 * option is its place in the list and the value handed back is the action's own
 * (a number stays a number).
 */
export function SelectControl({ id, setting, value, onChange, disabled, invalid, describedBy }: ControlProps) {
  const options = Array.isArray(setting.enum) ? setting.enum : [];
  const index = options.findIndex((o) => o === value);
  return (
    <Select
      value={index >= 0 ? String(index) : undefined}
      onValueChange={(v) => onChange(options[Number(v)])}
      disabled={disabled}
    >
      <SelectTrigger id={id} className="h-8 w-full" aria-invalid={invalid || undefined} aria-describedby={describedBy}>
        <SelectValue placeholder="Choose…" />
      </SelectTrigger>
      <SelectContent>
        {options.map((o, i) => (
          <SelectItem key={i} value={String(i)}>
            {optionLabel(o)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
